import ResourcePattern from '@/services/resource-patters';

export default ResourcePattern(null, 'modalpopup', () => ({
  state: {
    inputValue: null,
  },

  getters: {
    getInputValue: (state) => state.inputValue,
  },

  actions: {
    async setInputValue({ commit }, { inputValue }) {
      commit('SET_INPUT_VALUE', inputValue);
    },
  },

  mutations: {
    SET_INPUT_VALUE(state, value) {
      state.inputValue = value;
    },
  },
}));
